// v84.31 — Global pub/sub tipis utk sinkronisasi lintas halaman/komponen setelah
// WO dibuat/diubah/dihapus. Dipakai supaya CalendarBoard (Dashboard) langsung
// reload begitu admin klik "Buat WO" di halaman /work-orders (dan vice versa).
//
// Pemakaian:
//   dispatchWOChanged({wo, source})           // producer (setelah create/update)
//   const off = onWOChanged(handler); off()   // consumer (useEffect)
//
// Payload event: { detail: { wo?, source?, ts } }

const EVT = "wo-changed";

export function dispatchWOChanged(detail = {}) {
  try {
    window.dispatchEvent(new CustomEvent(EVT, {
      detail: { ...detail, ts: Date.now() },
    }));
  } catch { /* SSR-safe no-op */ }
}

export function onWOChanged(handler) {
  const wrapped = (e) => { try { handler(e.detail || {}); } catch {} };
  window.addEventListener(EVT, wrapped);
  return () => window.removeEventListener(EVT, wrapped);
}
